function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

export function buildQueryString(params) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, item));
    } else {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
}

export function parseFilterFromSearchParams(searchParams, defaultFilter) {
  const result = { ...defaultFilter };

  Object.keys(defaultFilter).forEach((key) => {
    if (!searchParams.has(key)) {
      return;
    }

    const defaultValue = defaultFilter[key];

    if (Array.isArray(defaultValue)) {
      result[key] = searchParams.getAll(key);
      return;
    }

    const rawValue = searchParams.get(key);

    if (rawValue === "true" || rawValue === "false") {
      result[key] = rawValue === "true";
    } else {
      result[key] = rawValue;
    }
  });

  return result;
}
// Builds a value that is safe to use in an HTML id / aria-labelledby
// reference: lowercased, whitespace runs collapsed to "-", and anything other
// than letters, digits, "-" and "_" stripped. ("Second Line Address" ->
// "second-line-address"; aria-labelledby breaks on ids containing spaces.)
export function toDomId(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9_-]/g, "");
}
